import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import {UserPopupChangeTracker} from '../user-popup-change-tracker';

class EditUserInTeam {
  constructor($scope, userInTeamService) {
    'ngInject';

    this.$scope = $scope;
    this.userInTeamService = userInTeamService;
    this.currentTab = 'general';
    this.changeTracker = new UserPopupChangeTracker();
  }

  $onInit() {
    this.loading = true;
    this.userInTeamService.get({ userId: this.resolve.userId, teamId: this.resolve.teamId })
      .then((user) => {
        this.loading = false;
        this.user = user;
        this.roleOptions = user.roles;
        this.selectedRole = find(this.roleOptions, x => x.id === this.user.roleId);
        this.updateWeekDayConfig();
        this.changeTracker.register(this);
      });

    this.$scope.$watch('$ctrl.user.workingDayInherit', () => this.updateWeekDayConfig());
  }

  onTabChange(tab) {
    this.currentTab = tab;
  }


  updateWeekDayConfig() {
    if (!this.user) return;
    this.currentWeekDayConfig = cloneDeep(this.user.workingDayInherit
      ? this.user.teamWorkingTimings.weekDayConfig
      : this.user.workingTimings.weekDayConfig);
  }

  onSelectedRole() {
    this.user.roleId = this.selectedRole.id;
  }

  save() {
    this.loading = true;
    this.userInTeamService.update({
      userId: this.user.userId,
      teamId: this.resolve.teamId,
      projectId: this.user.projectId,
      isActive: this.user.isActive,
      roleId: this.user.roleId,
      workingDayInherit: this.user.workingDayInherit,
      workingTimings: this.user.workingTimings,
      dayOverrides: this.user.dayOverrides
    })
    .then((data) => {
      this.loading = false;
        if (data && data.statusCode <= 0) {
            ttb.Notifications.ShowErrorMessage('User Configuration', data.statusMessage);
        }
        else 
        {
        this.$scope.userInTeamForm.$setPristine();
        this.close();
        ttb.Notifications.ShowSaveSuccessMessage('User Configuration', 'All the changes have been saved');
        }
      });
  }

  onDaysOfWeekChange() {
    this.updateWeekDayConfig();
  }
}

export default EditUserInTeam;



// WEBPACK FOOTER //
// ./components/popups/user-popup/edit-user-in-team/edit-user-in-team.controller.js